// extracted by mini-css-extract-plugin
export default {"content":"BaseInputDialog__content--1CH9w","waitText":"BaseInputDialog__waitText--pIAcu","input":"BaseInputDialog__input--x5QKo"};